import { IStore } from '../reducers';

export const networkSelector = (state: IStore) => {
  const networkState = state.network.selected;

  return networkState;
};
